import { ExpressionModel } from '../../Models/ExpressionModel';
import { ExpressionTypes } from '../../Models/ExpressionTypes';
import { VarExpressionModel } from '../../Models/VarExpressionModel';
import { IVariableScope } from '../../Models/VariableScopes/IVariableScope';
import ExpressionVariableScopeCalculatorService from '../../Services/ExpressionVariableScopeCalculatorService';

/**
 * Returns the effective variable scope for a parameter, accounting for the
 * VarExpression.Target special case: when editing the `Value` path of a Var
 * expression that has a Target, the scope should be scoped to that target.
 */
export function resolveVarTargetScope(
    expressionType: string | undefined,
    expression: ExpressionModel | undefined,
    paramName: string,
    baseScope: IVariableScope | undefined,
    expressionScopeCalculator: ExpressionVariableScopeCalculatorService | null | undefined,
): IVariableScope | undefined {
    if (expressionType === ExpressionTypes.Var && expression) {
        const varExpression = expression as VarExpressionModel;
        if (varExpression.Target && paramName === 'Value') {
            return expressionScopeCalculator?.calculateVariableScopeFromTarget(varExpression.Target, baseScope) ?? baseScope;
        }
    }
    return baseScope;
}
